import { render, staticRenderFns } from "./TenantBar.vue?vue&type=template&id=f833387a&"
import script from "./TenantBar.vue?vue&type=script&lang=js&"
export * from "./TenantBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports